import { render, staticRenderFns } from "./FormFilter.vue?vue&type=template&id=7015142f&"
import script from "./FormFilter.vue?vue&type=script&lang=js&"
export * from "./FormFilter.vue?vue&type=script&lang=js&"
import style0 from "./FormFilter.vue?vue&type=style&index=0&id=7015142f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem});
